import { Chip } from "@mui/material";
import { PictureAsPdfOutlined } from "@mui/icons-material";
import AttachmentItem from "components/Attachments/AttachmentItem";
import CopyAttachmentButton from "components/Attachments/CopyAttachmentButton";
import { isPreviewableImage } from "utils/attachmentPreview";

const renderFileChip = (file) => (
  <span key={file.url} className="inline-flex items-center">
    <Chip
      size="small"
      icon={<PictureAsPdfOutlined fontSize="small" />}
      label={file.fileName || "Attachment"}
      component="a"
      href={file.url}
      target="_blank"
      rel="noreferrer"
      clickable
    />
    <CopyAttachmentButton url={file.url} />
  </span>
);

const isImage = (file) => isPreviewableImage(file.url, file.contentType);

/**
 * Images as thumbnails that open a large preview, anything else as a chip that opens the signed
 * file in a new tab; each can be copied to paste into a note or comment elsewhere.
 */
const AttachmentList = ({ attachments }) => {
  if (!attachments?.length) return null;
  const images = attachments.filter(isImage);
  const others = attachments.filter((file) => !isImage(file));
  return (
    <div className="mt-2 space-y-2">
      {images.length ? (
        <div className="flex flex-wrap gap-2">
          {images.map((file) => (
            <AttachmentItem
              key={file.url}
              url={file.url}
              contentType={file.contentType}
              renderFile={() => renderFileChip(file)}
            />
          ))}
        </div>
      ) : null}
      {others.length ? (
        <div className="flex flex-wrap gap-2">{others.map(renderFileChip)}</div>
      ) : null}
    </div>
  );
};

export default AttachmentList;
